import {apiService} from '../../helpers/axios'
import {ResponseApi} from '../models/_public'

export function postUpdateSettingAdsMedia(dataForm: Partial<any>): Promise<ResponseApi<any>> {
  return apiService.post(`partner-setting/ads`, dataForm)
}
